import { render, staticRenderFns } from "./TestimonialSection.vue?vue&type=template&id=ef75e7d6&scoped=true"
import script from "./TestimonialSection.vue?vue&type=script&lang=ts"
export * from "./TestimonialSection.vue?vue&type=script&lang=ts"
import style0 from "./TestimonialSection.vue?vue&type=style&index=0&id=ef75e7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef75e7d6",
  null
  
)

export default component.exports